(() => {
  if (window.__DLM_QUICK_ADD_SCRIPT_LOADED__) return;
  window.__DLM_QUICK_ADD_SCRIPT_LOADED__ = true;

const DLM_QUICK_ADD_CACHE = new Map();

let dlmQuickAddProductInfoRequest;

const dlmEnsureQuickAddProductInfo = (html) => {
  if (customElements.get('product-info')) return Promise.resolve();

  if (!dlmQuickAddProductInfoRequest) {
    dlmQuickAddProductInfoRequest = new Promise((resolve, reject) => {
      const source = [...html.querySelectorAll('script[src]')].find((script) =>
        /\/product-info\.js(?:\?|$)/.test(script.getAttribute('src'))
      );
      if (!source) {
        reject(new Error('Quick add product-info script missing'));
        return;
      }
      const script = document.createElement('script');
      script.src = source.getAttribute('src');
      script.onload = () => {
        if (customElements.get('product-info')) resolve();
        else reject(new Error('Quick add product-info failed to initialize'));
      };
      script.onerror = () => {
        script.remove();
        reject(new Error('Quick add product-info failed to load'));
      };
      document.head.appendChild(script);
    }).catch((error) => {
      dlmQuickAddProductInfoRequest = undefined;
      throw error;
    });
  }

  return dlmQuickAddProductInfoRequest;
};

const dlmFetchQuickAddProduct = (url) => {
  if (!url) return Promise.reject(new Error('Missing quick-add product URL'));

  if (!DLM_QUICK_ADD_CACHE.has(url)) {
    const request = fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Quick add request failed: ${response.status}`);
        return response.text();
      })
      .catch((error) => {
        DLM_QUICK_ADD_CACHE.delete(url);
        throw error;
      });

    DLM_QUICK_ADD_CACHE.set(url, request);
  }

  return DLM_QUICK_ADD_CACHE.get(url);
};

const dlmInitCartQuickAddPrefetch = () => { const buttons = [...document.querySelectorAll('modal-opener .quick-add__submit[data-product-url]')];
  if (!buttons.length) return;

  const warm = (button) => {
    const url = button.getAttribute('data-product-url');
    if (url) dlmFetchQuickAddProduct(url).catch(() => {});
  };
 const initialWarmCount = window.matchMedia('(max-width: 749px)').matches ? 4 : 2;
 buttons.slice(0, initialWarmCount).forEach((button) => warm(button));

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          warm(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '900px 0px' }
    );

    buttons.forEach((button) => observer.observe(button));
  }

  buttons.forEach((button) => {
    button.addEventListener('pointerenter', () => warm(button), { once: true, passive: true });
    button.addEventListener('focus', () => warm(button), { once: true });
    button.addEventListener('touchstart', () => warm(button), { once: true, passive: true });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dlmInitCartQuickAddPrefetch, { once: true });
} else {
  dlmInitCartQuickAddPrefetch();
}

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.dlmVariantUpdatePending = false;
        this.dlmQueuedAddToCart = false;
        this.dlmVariantUpdateToken = 0;

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        this.addEventListener('change', (event) => {
          if (!event.target.closest('variant-selects, variant-radios')) return;
          this.dlmHandleVariantSelection();
        });

        this.addEventListener(
          'pointerdown',
          (event) => {
            if (!this.dlmVariantUpdatePending) return;
            if (!event.target.closest('button[type="submit"][name="add"], .product-form__submit')) return;
            this.dlmQueuedAddToCart = true;
          },
          true
        );
      }

      dlmGetAddToCartButton() {
        return this.modalContent.querySelector('button[type="submit"][name="add"], .product-form__submit');
      }

      dlmRevealAddToCart() {
        const button = this.dlmGetAddToCartButton();
        if (!button) return;

        const modalDialog = this.querySelector('.quick-add-modal__content');
        const contentInfo = this.querySelector('.quick-add-modal__content-info');

        const scrollToEnd = (element) => {
          if (!element) return;
          element.scrollTop = element.scrollHeight;
          if (typeof element.scrollTo === 'function') {
            element.scrollTo({ top: element.scrollHeight, behavior: 'auto' });
          }
        };

        // Mobil ist .quick-add-modal__content der eigentliche Scrollbereich.
        // Zusätzlich ziehen wir den inneren Bereich mit, falls Browser/CSS dort scrollt.
        scrollToEnd(contentInfo);
        scrollToEnd(modalDialog);
        scrollToEnd(this.modalContent);

        // Shopify ersetzt nach einer Variantenwahl Teile des Produkt-HTML.
        // Deshalb nach dem DOM-Update erneut bis zum maximalen Ende ziehen.
        requestAnimationFrame(() => {
          scrollToEnd(contentInfo);
          scrollToEnd(modalDialog);
          scrollToEnd(this.modalContent);
        });

        setTimeout(() => {
          scrollToEnd(contentInfo);
          scrollToEnd(modalDialog);
          scrollToEnd(this.modalContent);
        }, 80);
      }

      dlmHandleVariantSelection() {
        const token = ++this.dlmVariantUpdateToken;
        const previousVariantId = this.modalContent.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
        this.dlmVariantUpdatePending = true;
        this.dlmQueuedAddToCart = false;
        this.dlmRevealAddToCart();
        requestAnimationFrame(() => this.dlmRevealAddToCart());

        const startedAt = performance.now();
        const waitForVariant = () => {
          if (token !== this.dlmVariantUpdateToken) return;

          const variantInput = this.modalContent.querySelector('form[action*="/cart/add"] input[name="id"]');
          const button = this.dlmGetAddToCartButton();
          const variantReady = Boolean(variantInput?.value) && (variantInput.value !== previousVariantId || performance.now() - startedAt > 250);
          const buttonReady = Boolean(button) && !button.disabled && button.getAttribute('aria-disabled') !== 'true';

          if (variantReady && buttonReady) {
            this.dlmVariantUpdatePending = false;
            this.dlmRevealAddToCart();
            if (this.dlmQueuedAddToCart) {
              this.dlmQueuedAddToCart = false;
              requestAnimationFrame(() => this.dlmGetAddToCartButton()?.click());
            }
            return;
          }

          if (performance.now() - startedAt < 2000) {
            requestAnimationFrame(waitForVariant);
          } else {
            this.dlmVariantUpdatePending = false;
            this.dlmQueuedAddToCart = false;
            this.dlmRevealAddToCart();
          }
        };

        requestAnimationFrame(waitForVariant);
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        this.dlmVariantUpdatePending = false;
        this.dlmQueuedAddToCart = false;
        this.dlmVariantUpdateToken += 1;

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        dlmFetchQuickAddProduct(opener.getAttribute('data-product-url'))
          .then(async (responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            await dlmEnsureQuickAddProductInfo(responseHTML);
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.modalContent.querySelector('product-component')?.dispatchViewEvent?.();

            super.show(opener);

            requestAnimationFrame(() => {
              const modalDialog = this.querySelector('.quick-add-modal__content');
              if (modalDialog) modalDialog.scrollTop = 0;
              this.modalContent.scrollTop = 0;
            });
          })
          .catch(() => {
            window.location.assign(opener.getAttribute('data-product-url'));
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

})();
